import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@mui/material';
import React from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import {useDeletePaymentMethodMutation} from 'api';
import {useSnackbar} from 'notistack';

function PaymentMethodDeleteIconButton({PaymentMethodId}) {
  const [deletePaymentMethod, deletePaymentMethodResult] = useDeletePaymentMethodMutation();
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const {enqueueSnackbar} = useSnackbar();

  const handleDelete = async () => {
    try {
      await deletePaymentMethod(PaymentMethodId).unwrap();
      enqueueSnackbar('PaymentMethod deleted', {variant: 'success'});
      setIsModalOpen(false);
    } catch (error) {
      const message = error.status === 400 ? error.data?.details?.[0]?.message : undefined;
      enqueueSnackbar(message || `Error deleting PaymentMethod`, {variant: 'error'});
    }
  };

  return (
    <>
      <Dialog open={isModalOpen} maxWidth="xs">
        <DialogTitle>Delete Payment Method</DialogTitle>
        <DialogContent dividers>Are you sure you want to delete this Payment Method?</DialogContent>
        <DialogActions>
          <Button
            disabled={deletePaymentMethodResult.isLoading}
            autoFocus
            onClick={() => setIsModalOpen(false)}
          >
            Cancel
          </Button>
          <Button
            disabled={deletePaymentMethodResult.isLoading}
            color="error"
            endIcon={deletePaymentMethodResult.isLoading ? <CircularProgress size={16} /> : null}
            onClick={handleDelete}
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
      <IconButton
        onClick={() => setIsModalOpen(true)}
        disabled={deletePaymentMethodResult.isLoading}
        aria-label="delete"
        color="error"
      >
        <DeleteIcon />
      </IconButton>
    </>
  );
}

export default PaymentMethodDeleteIconButton;
